import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterTemplateList_template} from "../components/templates/newsletterTemplateList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class newsletter_templates extends vnModule_knockoutJS {

    protected XHRHdl!: XMLHttpRequestHandler;
    protected newsletterTemplateList!: newsletterTemplateList_template;
    protected pagination!: pagination_template;

    buildContent(): Array<Element> {
        this.newsletterTemplateList = new newsletterTemplateList_template("newsletterTemplateList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Template List");
        return [this.newsletterTemplateList.build()];
    }

    protected getModuleName(): string {

        return "newsletter_templates";
    }

    fillPage() {

        this.getTemplateListData();
    }

    protected getTemplateListData() {

        this.loadingIn(this.newsletterTemplateList.builtTemplate.children.namedItem("list-results")!);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.newsletterTemplateList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/newsletter/templates/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTemplateListDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetTemplateListDataReturn(req: any, obj: any) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let templates = responseParsed.data;


                obj.viewModel.newsletterTemplateList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.newsletterTemplateList.setResultInfo(totalCount, totalPage, execTime)

                let brandId = obj.getBrandId();
                obj.newsletterTemplateList.setTemplates(templates, brandId)

            });
            obj.loadingOut(obj.newsletterTemplateList.builtTemplate.children.namedItem("list-results")!);
        }
    }

    protected templatesListReorder() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getTemplateListData()
    }

    protected paginationOnPageClick() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getTemplateListData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.newsletterTemplateList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.newsletterTemplateList.builtTemplate.children.namedItem("list-results")!);

        let templateReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/get/';
        let mailReq_params: Array<Array<string>> = [];
        mailReq_params.push(["data", ko.toJSON(this.newsletterTemplateList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(templateReq_url,mailReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req: any, obj: any){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterTemplateList.setTemplates(responseParsed.data);

                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime)/1000*100)/100;
                obj.newsletterTemplateList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

                // update the paginator
                obj.viewModel.newsletterTemplateList.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.newsletterTemplateList.builtTemplate.children.namedItem("list-results")!);
        }
    }

    protected view(id: any) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/view/' + id + '/')
    }

    protected add() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/add/')
    }

    protected manageImages() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/images/')
    }

    protected manageColors() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/colors/')
    }

    protected delete(data: any) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/newsletter/templates/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.newsletterTemplateList.builtTemplate.children.namedItem("list-results")!);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req: any, obj: any) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Template" + "<strong>" + data.label + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getMailingListData()
                })

                obj.loadingOut(obj.newsletterTemplateList.builtTemplate.children.namedItem("list-results")!);

            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

}


// WEBPACK FOOTER //
// ./js/modules/newsletter_templates.ts